module.exports = "icons/solar-panel.svg";